import React from 'react';
import { useParams } from 'react-router-dom';
import { ContactKey } from 'flow/types/EntityKeys';
import ContactContainers from 'flow/components/contact-card/ContactContainers';

interface RouteExternalContactParams {
    contactKey: ContactKey;
}

const RouteExternalContact: React.FC = () => {
    const { contactKey } = useParams<RouteExternalContactParams>();
    return <ContactContainers parentContactKey={contactKey} />;
};

export default RouteExternalContact;
